import React, { PropTypes, Component } from "react";

import MeterScale from "./MeterScale";

import MeterArrow from "./MeterArrow";

import ProgressMeter from "./ProgressMeter";

import styled from "styled-components";

import {
	NitroIcon,
	NitroHeading,
	NitroGrids,
	NitroGrid,
	NitroPlaceholder,
	NitroText
} from "nitro-components";

const ComparisonContentContainer = styled.div`
  display: -ms-flex;
  display: -webkit-flex;
  display: flex;
  position: relative;
  bottom: 0;
  height: 44px;
  width: 100%;
  margin-bottom: ${props => (props.noBottomMargin ? 0 : 25)}px;
  & > div:first-child {
    width:26%;
  }
  & > div{
    width:74%;
  }
`;

const ValueIndicatorContainer = styled.div`
	position:relative;
	z-index:999;
`;

const ValueIndicatorHint = styled.div`
 border-radius: 100px;
 background-color: ${props => props.theme.color[props.variant]};
 padding-top:1px;
 padding-bottom:1px;
 padding-left:5px;
 padding-right:5px;
 position:absolute;
 margin-left:${props => props.left - 10}%;
 margin-top:-48px;
 text-align:center;
 font-size:10px;
 color:${props => props.theme.color.white};
 `;

const MeterContentContainer = styled.div`
	margin-left:26%;
	position:relative;
`;

const ComparisonSection = styled.section`
  margin-bottom: ${props => props.Bottom}px;
  margin-top: ${props => props.Top}px;
  padding-bottom: 13px;
  border-bottom: 1px solid ${props => props.theme.color.border};
  positon:relative;
`;

const ComparisonContent = styled.div`
width: 100%;
float:left;
`;

const MeterArrows = ({ meterData }) => (
	<MeterContentContainer>
		{meterData.map(function(item, i) {
      const arrowDistance = 115;
      const graphHeight = 70;

			return (
				<MeterArrow
					height={arrowDistance - (i * graphHeight)}
					left={item.MeterValue > 100 ? 100 : item.MeterValue}
					variant={(item.MeterVariant)? item.MeterVariant:'base2'}
					top={item.MeterValue > 100 ? 9 : (i * graphHeight)}
					key={i}
				/>
			);
		})}
	</MeterContentContainer>
);

const MeterValueIndicator = ({ meterData }) => (
	<MeterContentContainer>
		{meterData.map(function(item, i) {
			return (
				<ValueIndicatorHint
					left={item.MeterValue > 100 ? 100 : item.MeterValue}
					variant={(item.MeterVariant)? item.MeterVariant:'base2'}
					key={i}
				>
					some
				</ValueIndicatorHint>
			);
		})}
	</MeterContentContainer>
);

const MeterBars = ({ meterData }) => (
	<div>
		{meterData.map(function(item, i) {
			return (
				<ComparisonContentContainer
					noBottomMargin={i === meterData.length - 1} key={i}
				>
					<ComparisonContent>
						<NitroText variant={item.MeterVariant} bold>
							{item.MeterCategory}
						</NitroText>
						<NitroIcon
							name={item.MeterIndicator}
							size={22}
							left={12}
							top={10}
							variant={item.MeterVariant}
							shadow
						/>
					</ComparisonContent>
					<ComparisonContent>

						<ProgressMeter
							variant={(item.MeterVariant)? item.MeterVariant:'base2'}
							fillPercentWidth={
								item.MeterValue > 100 ? 100 : item.MeterValue
							}
						/>
						<ValueIndicatorContainer>
							<ValueIndicatorHint
								left={
									item.MeterValue > 95
										? 95
										: item.MeterValue
								}
								variant={(item.MeterVariant)? item.MeterVariant:'base2'}
								key={i}
							>
								{item.MeterDisplayText}
							</ValueIndicatorHint>
						</ValueIndicatorContainer>

					</ComparisonContent>
				</ComparisonContentContainer>
			);
		})}
	</div>
);

const ComparisonMeter = props => {
	const {
		TimeMetric,
		MinTime,
		MaxTime,
		TimeBreakInterval,
		Top,
		Bottom,
		Variant,
		MeterData
	} = props;

	return (
		<ComparisonSection Top={Top} Bottom={Bottom}>
			<MeterArrows meterData={MeterData} />
			<MeterBars meterData={MeterData} />
			<ComparisonContentContainer>
				<ComparisonContent />
				<ComparisonContent>
					<MeterScale
						metric={TimeMetric}
						min={MinTime}
						max={MaxTime}
						interval={TimeBreakInterval}
						skipAlternateMetric

					/>
				</ComparisonContent>
			</ComparisonContentContainer>

		</ComparisonSection>
	);
};

ComparisonMeter.defaultProps = {
	Top: 10,
	Bottom: 20
};

ComparisonMeter.propTypes = {
	TimeMetric: PropTypes.string,
	MinTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	MaxTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	TimeBreakInterval: PropTypes.array,
	Variant: PropTypes.string,
	Bottom: PropTypes.number,
	Top: PropTypes.number,
	MeterData: PropTypes.array
};

export default ComparisonMeter;



// WEBPACK FOOTER //
// ./src/components/comparison/ComparisonMeter.js